<template>
  <div class="listmain ">
      <h1 class="firTitle">支付服务</h1>
      <span>
 <h3 class="sedTitle">打开猎户支付，先到支付确认界面，然后点“立即支付”进入支付页面</h3>

</span>
          <highlight-code lang="javascript">
             <span>
                 NSDictionary *params = @{
    @"orderNo":@"15106377430921271287808324293",
    @"payAccessToken":@"e29d9a21e42342e0b443c01528bb09c0",
    @"pictures":@[@"http://www.baidu.com/pic/1234567.png"],
    @"subSubject":@"大卡读书会",
    @"subject":@"我爱读书",
    @"amount":@"9.9"
};
[[OrionSDK shared] payConfirmByOrderInfo:params withCompletion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    NSLog(@"%@,%@",conversationInfo,error);
}]
             </span>
    </highlight-code>

      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">NOTE：<br>
              状态码 901 需要特殊处理，因为支付完成，可能回调关闭太慢，用户会主动关闭支付结果页面，这个时候会弹出提示让用户选择“返回” 或者 “确认支付完成”。<br>
              建议：<br>
              code：901 接入方选择刷新列表更新状态<br>
              code：902 是用户选择“取消支付”<br>
              error的值为nil,则说明支付成功</span>
      </p>

      <h3 class="sedTitle">直接进入支付页面</h3>

      <highlight-code lang="javascript">
         <span>
             NSDictionary *params = @{
    @"orderNo":@"15106377430921271287808324293",
    @"payAccessToken":@"e29d9a21e42342e0b443c01528bb09c0",
    @"pictures":@[@"http://www.baidu.com/pic/1234567.png"],
    @"subSubject":@"大卡读书会",
    @"subject":@"我爱读书",
    @"amount":@"9.9"
};
[[OrionSDK shared] payByOrderInfo:params withCompletion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
    NSLog(@"%@,%@",conversationInfo,error);
}];
         </span>
      </highlight-code>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
            NOTE：<br>
状态码901需要特殊处理，因为支付完成，可能回调关闭太慢，用户会主动关闭支付结果页面，这个时候会弹出提示让用户选择“返回” 或者 “确认支付完成”。<br>
建议：<br>
code：901接入方选择刷新列表更新状态<br>
code：902 是用户选择“取消支付”<br>
error的值为nil,则说明支付成功</span>
      </p>

  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/Payment.vue